module.exports = "/wwwroot/img/waste_type_page.png?ver=afa384d6";